export default {
  insurance: null,
  insured: null,
  stage: null,
  sinisterCode: null,
  sinisterVersion: null,
  expert: null,
  analyst: null,
  sinisterDateStart: null,
  sinisterDateEnd: null,
  lighthouse: null,
  ranking: null,
  expertID: null,
  plate: null,
  regulationType: null,
  schedulingType: null,
  budgetSystem: null,
  product: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/auto/sinistersearchmodel.js